import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import AboutContent from './components/AboutContent';

export default function About() {
  return (
    <>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <AboutContent />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}